import http from '../http'

export default {
  getPermissions: () => {
    return http.get('/permission')
  },
  createPermission: (permission) => {
    return http.post('/permission', permission)
  },
  getModules: () => {
    return http.get('/permission/modules')
  }
}
